module.exports = __webpack_public_path__ + "static/media/edit-photo.d063875f.svg";